<template>
  <div
    v-if="getDescriptionOfAnswer(participant, choice)"
    @click="toggleChoiceIfEnabled($event, particiant, choice)"
    :class="getCssOfAnswer(participant, choice)"
    class="choice-response-description mt-1 pointer"
  >
    {{ getDescriptionOfAnswer(participant, choice) }}
      </div>
</template>
<script>
import { renderMixin } from '../mixins/RenderMixins';
export default {
  name: 'RenderDescriptionOfAnswer',
  mixins: [renderMixin],

 props: {
    participant: {
      type: Object,
      mandatory: true
    },
    choice: {
      type: Object,
      mandatory: true
    }

}
}
</script>
